import { Injectable } from '@angular/core';
import { BaseService } from '../../../../modules/shared/services';
import { apiUrls } from '../../../../constants';
import { Observable, map } from 'rxjs';
import { Contract, ContractConfirmStateType } from '../models/contract.model';

@Injectable({
	providedIn: 'root'
})
export class ContractService extends BaseService {
	private get url(): string {
		return `${this.mtsPath + apiUrls.contract}contract`;
	}
	get(): Observable<Contract[]> {
		return this.httpService.get<Contract[]>(this.url).pipe(
			map(res =>
				res.map(item => {
					item.confirmState ??= ContractConfirmStateType.NotRequested;
					return item;
				})
			)
		);
	}
	confirmContract(contractType: string) {
		return this.httpService.post<Contract[]>(`${this.url}/otp`, { body: { contractType } });
	}
	sendOtp(contractRequest: { id: string; token: string }) {
		return this.httpService.post<Contract[]>(`${this.url}/add`, { body: { contractRequest } });
	}
}
